import { sha256 } from 'js-sha256';

// Display artwork can be smaller than its stored original. Compare restored
// values to that original without rewriting values or sending them anywhere.
export const hasNewImagePreview = (value, field) => {
  if (!value) return false;
  if (typeof value === 'string' && /^[a-f0-9]{64}$/.test(field.intakeOriginalImageSha256 || '')) {
    return sha256(value) !== field.intakeOriginalImageSha256;
  }
  return value !== field.uploadedImage;
};
